import { Stack, Typography } from "@mui/material";
import ActionButton from "@quest_editor/components/Buttons/ActionButton";
import BackButton from "@quest_editor/components/Buttons/BackButton";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import BasicInfoSection from "./BasicInfoSection";
import OptionSection from "./OptionSection";

const PromotionRegister = () => {
  const { t } = useTranslation("questEditor");

  return (
    <Stack direction="column" spacing={2}>
      <Typography variant="h6" component="h2">
        {t("promotion_register.title")}
      </Typography>

      <BasicInfoSection />
      <OptionSection />

      <Stack
        direction="row"
        spacing={2}
        justifyContent="center"
        alignItems="center"
        sx={{ position: "relative" }}
      >
        <BackButton
          component={Link}
          to="/quest_editor"
          sx={{ position: "absolute", left: 0 }}
        >
          {t("promotion_register.button.back")}
        </BackButton>
        <ActionButton>
          {t("promotion_register.button.register")}
        </ActionButton>
      </Stack>
    </Stack>
  );
};
export default PromotionRegister;
